import * as React from 'react';
import { FIELD_CLASSES } from '@/components/ui/field-styles';
import { cn } from '@/lib/utils';

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        // 16 px no mobile evita o zoom automático do iOS; 14 px a partir de md
        'flex h-10 w-full min-w-0 rounded-md px-3 py-1 text-base file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground/80 selection:bg-primary selection:text-primary-foreground md:h-9 md:text-sm',
        FIELD_CLASSES,
        className,
      )}
      {...props}
    />
  );
}

export { Input };
